import { Dispatch, FC, SetStateAction } from 'react';

interface EmailSearchBarProps {
    email: string;
    setEmail: Dispatch<SetStateAction<string>>;
    submitSearch: () => void;
    clearSearch: () => void;
}

export const EmailSearchBar: FC<EmailSearchBarProps> = ({ email, setEmail, submitSearch, clearSearch }) => {

    return (
        <div className="search-bar">
            <form onSubmit={submitSearch} id="user-search-bar-container">
                <div className="two-columns-expand-two">
                    <label htmlFor="search-query" className="vertical-align mr-m">Email:</label>
                    <input
                        type="text"
                        id="search-query"
                        className="pl-m"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        placeholder="Enter email"
                    />
                </div>
                <div className="three-columns-auto">
                    <button type="submit" className="searchBy-btn bold white-text">SEARCH</button>
                    <button type="button" onClick={() => clearSearch()} className="searchBy-btn white-text bold">CLEAR</button>
                </div>
            </form>
        </div>
    );
};